import { ProductOrder, Customer, Company } from './index';
import { StringHelpers } from '../helpers/string-helpers';
import { Utils } from '../helpers/utils';

export class OnlineOrder {
	id: number;
	
	company_id: number;
	status: 'pending'|'cancelled'|'confirmed'|'producing'|'produced'|'in_transit'|'delivered'|'evaluated';
	reason: string; // when it's cancelled

	product_orders: ProductOrder[];
	product_orders_attributes: ProductOrder[];

	customer: Customer;
	customer_id: number;
	customer_attributes: Customer;

	text_representation: string;

	payment_type: 'credit'|'debit'|'cash';
	change_needed: number;

	delivery_info: string; // {mode: 'delivery'|'pickup', address: string, district: string }

	eval_code: string;

	created_at: string;
	updated_at: string;

	// additional info server sends us
	company: Company;
	delivery_company_name: string;
	delivery_fee: string;

	// set by our front end app
	prettyCompanyName: string;
	prettyTotal: string;
	statusPtBr: string;
	timeSince: string;
	parsedDeliveryInfo: {
		mode: string,
		address: string,
		district: string
	};

	static setAdditionalData(oo: OnlineOrder) {
		if(oo.company)
			oo.prettyCompanyName = StringHelpers.deparameterize(oo.company.name);

		if(oo.status)
			oo.statusPtBr = OnlineOrder.statusPtBr(oo.status);

		if(oo.created_at)
			oo.timeSince = Utils.timeSince(oo.created_at, new Date());

		if(oo.delivery_info)
			oo.parsedDeliveryInfo = JSON.parse(oo.delivery_info);
		else
			oo.parsedDeliveryInfo = {mode: null, address: null, district: null};

		if(oo.product_orders) {
			let total = 0;
			for(let po of oo.product_orders) {
				total += Number(po.un_price) * po.quantity;
			}
			total += Number(oo.delivery_fee) || 0;
			oo.prettyTotal = total.toFixed(2).replace('.',',');
		}
	}

	static statusPtBr(status: string): string {
		switch(status) {
			case "pending": return "pendente";
			case "cancelled": return "cancelado";
			case "confirmed": return "confirmado";
			case "producing": return "em preparo";
			case "produced": return "preparo finalizado";
			case "in_transit": return "a caminho";
			case "delivered": return "entregue";
			case "evaluated": return "entregue e avaliado";
		}
	}
}